import { NavLink } from 'react-router-dom';
import { useLanguage } from '../../../context/LanguageContext';

export const navigationItems = [
  ['Home', '/'],
  ['Shop', '/shop'],
  ['About', '/about'],
  ['Contact', '/contact'],
  ['Track Order', '/track-order']
];

function Navbar({ onNavigate }) {
  const { t, translate } = useLanguage();
  const categoryItems = [
    [translate('Herbal Capsules'), '/shop?form=capsules'],
    [translate('Herbal Syrups'), '/shop?form=syrup'],
    [translate('Herbal Oil'), '/shop?form=oil']
  ];
  const visibleItems = [[t('home'), '/'], [t('shop'), '/shop'], [t('about'), '/about'], [t('contact'), '/contact'], [t('trackOrder'), '/track-order']];
  return (
    <nav aria-label="Primary navigation" className="navbar">
      <ul>
        {visibleItems.slice(0, 2).map(([label, path]) => <li key={path}><NavLink className={({ isActive }) => isActive ? 'navbar__link navbar__link--active' : 'navbar__link'} end={path === '/'} onClick={onNavigate} to={path}>{label}</NavLink></li>)}
        <li className="navbar__item--categories">
          <NavLink aria-haspopup="true" className={({ isActive }) => isActive ? 'navbar__link navbar__link--active' : 'navbar__link'} onClick={onNavigate} to="/categories">{translate('Categories')} <span aria-hidden="true" className="navbar__chevron">▾</span></NavLink>
          <ul aria-label={translate('Product Categories')} className="navbar__submenu">
            {categoryItems.map(([label, path]) => <li key={path}><NavLink onClick={onNavigate} to={path}>{label}</NavLink></li>)}
          </ul>
        </li>
        {visibleItems.slice(2).map(([label, path]) => <li key={path}><NavLink className={({ isActive }) => isActive ? 'navbar__link navbar__link--active' : 'navbar__link'} onClick={onNavigate} to={path}>{label}</NavLink></li>)}
      </ul>
    </nav>
  );
}

export default Navbar;
